import { breadcrumb } from './breadcrumb';
export const call_tracking = {
  breadcrumb,

  number: {
    field: {
      number: 'Number',
      status: 'Status',
      created_at: 'Date Added',
      client_id: 'Client ID',
      call_date: 'Call date',
      caller_number: "Caller's Phone"
    },

    modal: {
      remove: {
        content: 'Are you sure you want to stop using the number {number} for call tracking?'
      }
    }
  },

  integration: {
    connect: 'Connection',
    connect_desc: `Paste the fragment shown below on the site page immediately after the tag <code>&lt;head&gt;</code>. Instead of CLIENT_ID, specify a unique visitor identifier.`,
    get_number: 'Getting a number',
    get_number_desc: 'There will be an available phone number'
  },

  button: {
    create: 'Add number'
  }
};
